(function () {
  if (customElements.get('product-slider')) return;

  function waitForSwiper() {
    if (typeof Swiper !== 'undefined') {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      const swiperScript = document.getElementById('swiper-bundle-js');

      const finish = () => {
        if (typeof Swiper !== 'undefined') resolve();
      };

      if (swiperScript) {
        swiperScript.addEventListener('load', finish, { once: true });
      }

      const poll = window.setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          window.clearInterval(poll);
          resolve();
        }
      }, 50);

      window.setTimeout(() => {
        window.clearInterval(poll);
        finish();
      }, 10000);
    });
  }

  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.swiper = null;
      this.resizeTimeout = null;
      this.initPromise = null;
      this.onResize = this.handleResize.bind(this);
      this.onPageShow = this.handlePageShow.bind(this);
    }

    connectedCallback() {
      this.init();
      window.addEventListener('resize', this.onResize);
      window.addEventListener('pageshow', this.onPageShow);
    }

    disconnectedCallback() {
      this.cleanup();
      window.removeEventListener('pageshow', this.onPageShow);
    }

    handlePageShow(event) {
      if (event.persisted) {
        this.reinitSwiper();
      }
    }

    setupElements() {
      this.slider = this.querySelector('.product-slider');
    }

    initSwiper() {
      if (!this.slider || this.swiper) return;
      if (typeof Swiper === 'undefined') return;

      const prevEl = this.slider.querySelector('.swiper-button-prev');
      const nextEl = this.slider.querySelector('.swiper-button-next');

      this.swiper = new Swiper(this.slider, {
        direction: 'horizontal',
        loop: true,
        autoHeight: true,
        observer: true,
        observeParents: true,
        navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
      });

      this.slider.querySelectorAll('img').forEach((img) => {
        if (img.complete) return;
        img.addEventListener('load', () => this.swiper?.update(), { once: true });
      });
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.reinitSwiper(), 200);
    }

    reinitSwiper() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      waitForSwiper().then(() => {
        if (this.isConnected) this.initSwiper();
      });
    }

    cleanup() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      window.removeEventListener('resize', this.onResize);
      clearTimeout(this.resizeTimeout);
      this.initPromise = null;
    }

    init() {
      this.setupElements();
      if (!this.slider) return;

      if (!this.initPromise) {
        this.initPromise = waitForSwiper()
          .then(() => {
            if (!this.isConnected) return;
            this.initSwiper();
          })
          .catch(() => {});
      }

      return this.initPromise;
    }
  }

  customElements.define('product-slider', ProductSlider);

  document.addEventListener('shopify:section:load', (event) => {
    const slider = event.target.querySelector?.('product-slider');
    if (!slider) return;

    slider.initPromise = null;
    if (slider.swiper) {
      slider.reinitSwiper();
    } else {
      slider.init();
    }
  });
})();
